<template>
  <!-- Can't use <b-card> here because feedback slot in footer breaks things -->
  <div class="card">

    <div class="card-header">
      <div class="card-title">
        Asset Details
      </div>
    </div>

    <div
      v-if="asset"
      class="card-body">

      <asset-form
        :editing="editing"
        :asset="asset"
        :asset-types="assetTypes" />
    </div>

    <div
      v-else
      class="card-body">
      <p class="text-muted">
        No asset selected.
      </p>
    </div>

    <div
      v-if="canEdit && asset"
      class="card-footer">
      <div class="row">

        <div class="col-sm-12 col-lg-6">
          <div v-if="hasSlotContent('feedback')">
            <slot name="feedback" />
          </div>
        </div>

        <div class="col-sm-12 col-lg-6">
          <div class="float-lg-right">
            <div v-if="!editing">
              <div
                class="btn btn-secondary border border-dark"
                @click="startEditing">
                <i class="fa fa-edit" /> Edit
              </div>
              <div
                class="btn btn-danger border border-dark"
                @click="deleteAsset">
                <i class="fa fa-trash" /> Delete
              </div>
            </div>

            <div v-else>
              <div
                class="btn btn-primary border border-dark"
                @click="updateAsset">
                <i class="fa fa-save" /> Save
              </div>
              <div
                class="btn btn-secondary border border-dark"
                @click="cancelEditing">
                <i class="fa fa-undo" /> Cancel
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Utils from '../mixins/ObjectUtilsMixin';
import OptionalSlots from '../mixins/OptionalSlotsMixin';
import AssetForm from './AssetFormComponent';

export default {
    components: {
        'asset-form': AssetForm,
    },

    mixins: [
        Utils,
        OptionalSlots,
    ],

    props: {
        asset: {
            type: Object,
            default: null,
        },
        assetTypes: {
            type: Object,
            default: null,
        },
    },

    data() {
        return {
            editing: false,
            originalValues: null,
        };
    },

    computed: {
        canEdit() {
            // THIS IS ONLY TEMPORARY - IMPLEMENT PERMISSIONS!!!
            return true;
        },
    },

    watch: {
        asset(newAsset, oldAsset) {
            // so we can switch between assets if editing is on
            this.objectSet(oldAsset, this.originalValues);
            this.originalValues = this.objectCopy(this.asset);
        },
    },

    methods: {
        startEditing() {
            this.editing = true;
            this.originalValues = this.objectCopy(this.asset);
        },

        cancelEditing() {
            this.editing = false;
            this.objectSet(this.asset, this.originalValues);
            this.originalValues = null;
        },

        updateAsset() {
            let stopEditing = () => {
                this.editing = false;
                this.originalValues = null;
            };

            this.$parent.updateAsset(this.asset, stopEditing);
        },

        deleteAsset() {
            this.$parent.deleteSelectedItem();
        },
    },
};
</script>

<style>
    .notes-title {
        font-size: 14px;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/asset-register/AssetDetailsComponent.vue